<template>
	<div>
		<navTitle><div class="pageTitle">建言献策</div></navTitle>
		<div class="lineList">
			<div class="line flex flex-align-center flex-jus-center">
				<div>姓名：</div>
				<input v-model.trim="truename" type="text" class="flex-1" maxlength="25" />
			</div>
			<div class="line flex flex-align-center flex-jus-center">
				<div>手机号：</div>
				<input v-model="mobile" type="tel" class="flex-1" maxlength="11" />
			</div>
		</div>
		
		<div class="textList">
			<div class="title">意见反馈</div>
			<div class="textarea">
				<textarea v-model="feedback_content" maxlength="300" placeholder="请输入反馈的建议...."></textarea>
			</div>
			
		</div>
		<div @click="submit" class="submitBtn">提交</div>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			truename: '',
			mobile: '',
			feedback_content: ''
		};
	},
	created() {},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '建言献策',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		submit() {
			if (!this.truename) { this.$toast.fail('请输入姓名'); return }
			if (!this.mobile) { this.$toast.fail('请输入手机号'); return }
			let regxMobile = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
			if (!regxMobile.test(this.mobile)) { this.$toast.fail('请输入正确的手机号'); return false; }
			if (!this.feedback_content) { this.$toast.fail('请输入反馈内容'); return }
			this.$post('api/user/feedback', {
				truename: this.truename,
				mobile: this.mobile,
				feedback_content: this.feedback_content
			}).then(() => {
				this.truename = ''
				this.mobile = ''
				this.feedback_content = ''
				this.$toast('反馈成功')
			})
		}
	}
};
</script>

<style scoped lang="stylus">
.submitBtn
	position fixed
	left calc(50% - 188px)
	bottom 80px
	width 376px
	height 92px
	line-height 92px
	text-align center
	background-image url('~@/static/images/index/btnBG.png')
	background-size 100% 100%
	background-position center
	font-size: 32px;
	color: #FFFFFF;
.lineList
	padding 0 30px
	.line
		padding 30px 0
		border-bottom 2px solid #E6E6E6
		font-size 28px
		color #232220
		img
			width 12px
			height 24px
		input
			text-align right
.textList
	padding 40px 30px
	.title
		margin-bottom 28px
		font-size: 32px;
		font-weight: bold;
		color: #000000;
	.textarea
		padding 24px
		width 100%
		height: 360px;
		background: #F7F7F7;
		border-radius: 20px;
		textarea
			width 100%
			height 100%
			background-color inherit
			border none
			resize none
			font-size 28px
			color #000000
		textarea::-webkit-input-placeholder
			font-size 28px
			color #B1B1B1
		textarea:-moz-placeholder
			font-size 28px
			color #B1B1B1
		textarea::-moz-placeholder
			font-size 28px
			color #B1B1B1
		textarea::-ms-input-placeholder
			font-size 28px
			color #B1B1B1
</style>
